// components/PageLayout.jsx
import React from 'react';

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="text-xl font-semibold text-black mb-2">{title}</h2>
    <p className="text-[17px] text-gray-700 leading-relaxed whitespace-pre-line">{children}</p>
  </section>
);

const PageLayout = ({ pageTitle, subtitle, sections }) => {
  return (
    <div className="bg-white font-poppins px-4 sm:px-8 lg:px-16 py-16">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-black mb-4">{pageTitle}</h1>
        <p className="text-xl font-medium text-gray-800 mb-6">{subtitle}</p>
        <hr className="border-gray-300 mb-10" />
        {sections.map((sec, i) => (
          <Section key={i} title={`${sec.number}. ${sec.heading}`}>
            {sec.text}
          </Section>
        ))}
      </div>
    </div>
  );
};

export default PageLayout;
